import {observer} from 'mobx-react';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {useAccount} from 'wagmi';
import {useBreakpointContext} from '../../../context-providers/BreakpointProvider';
import {getDataGridCommonProps} from '../helpers/data-grid-common-props';

import {getStakeHistoryColumns, getStakeHistoryColumnsMobile} from '../helpers/columns';
import apiService from "../../../services/api/api.service";

const PAGE_SIZE = 100;
const emptyStateText = 'No history available';

const StakeHistory = observer(() => {

    const { address } = useAccount();
    const { xs } = useBreakpointContext();
    const [historyRecords, setHistoryRecords] = useState<any>([])
    const [paginationEnabled, setPaginationEnabled] = React.useState(false);

    useEffect(() => {
        async function fetch() {
            if (address) {
                const history = await apiService.stakingHistoryGet(address);
                setHistoryRecords(history)
                setPaginationEnabled(historyRecords.length > PAGE_SIZE);
            }
        }
        fetch()
    }, [address])


    return (
        <div className="StakeTabsNavigation__gridWrapper">
            {xs && <DataGrid
                {...getDataGridCommonProps(emptyStateText)}
                rows={historyRecords}
                columns={getStakeHistoryColumnsMobile()}
                hideFooter={!paginationEnabled}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: PAGE_SIZE }
                    },
                    sorting: {
                        sortModel: [{ field: 'dateTime', sort: 'desc' }]
                    }
                }}
            />}
            {!xs && <DataGrid
                {...getDataGridCommonProps(emptyStateText)}
                rows={historyRecords}
                columns={getStakeHistoryColumns()}
                hideFooter={!paginationEnabled}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: PAGE_SIZE }
                    },
                    sorting: {
                        sortModel: [{ field: 'dateTime', sort: 'desc' }]
                    }
                }}
            />}
        </div>
    );
});

export default StakeHistory;
